/** Sentry へ送るイベントから ID を伏せる。前半だけ残して残りを * に置き換える */
export const censorStringByLength = (
  idString: string,
  exposedLength: number = 0.5
) => {
  const length = idString.length;
  const el = Math.floor(length * exposedLength);
  const hiddenLength = length - el;
  const hiddenPart = "*".repeat(hiddenLength);
  return idString.substring(0, el) + hiddenPart;
};
